<template>
  <Drawer
    width="400"
    :title="`${openedMaterial ? '编辑' : '新增'}${convertedType}`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="材料名" prop="name">
          <Input v-model="formItem.name" placeholder="输入材料名..." />
        </FormItem>
        <FormItem label="型号" prop="model">
          <Input v-model="formItem.model" placeholder="输入型号..." />
        </FormItem>
        <FormItem label="用于母液" prop="usedForSemi" v-if="type === 'raw'">
          <i-switch v-model="formItem.usedForSemi" />
        </FormItem>
        <FormItem label="用于复配" prop="usedForProduct" v-if="type === 'raw'">
          <i-switch v-model="formItem.usedForProduct" />
        </FormItem>
        <FormItem label="禁用" prop="invalid">
          <i-switch v-model="isInvalid" true-color="#ff4949" @on-change="changeInvalid"></i-switch>
        </FormItem>
        <FormItem label="用于工厂" prop="usedInFactory">
          <Select v-model="formItem.usedInFactory" multiple filterable>
            <Option
              v-for="factory in factoryList"
              :value="factory._id"
              :key="factory._id"
            >{{ factory.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formItem.remark" type="textarea" placeholder="产品备注" />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import lodash from "lodash";

export default {
  name: "EditMaterialDrawer",
  components: {},
  props: {},
  data() {
    return {
      drawerOpened: false,
      type: null,
      isInvalid: false,
      openedMaterial: null,
      formItem: {
        name: "",
        model: null,
        usedForSemi: false,
        usedForProduct: false,
        usedInFactory: null,
        remark: null,
        invalid: null
      },
      ruleValidate: {
        name: [{ required: true, message: "材料名为必填项", trigger: "submit" }]
      }
    };
  },
  computed: {
    convertedType: function() {
      switch (this.type) {
        case "raw":
          return "原材料";
        case "semi":
          return "母液";
        case "product":
          return "产品";
        default:
          return "错误";
      }
    },
    ...mapState({
      factoryList: state => state.factory.factoryList
    })
  },
  methods: {
    ...mapActions({
      createMaterial: "material/createMaterialAction",
      updateMaterial: "material/updateMaterialAction",
      getFactoryList: "factory/getFactorysAction"
    }),
    openDrawer(type, material) {
      this.$refs["formItem"].resetFields();
      this.getFactoryList({});
      this.type = type;
      this.openedMaterial = material; // 如果有打开的材料，则为编辑模式
      if (material) {
        this.formItem.name = material.name;
        this.formItem.model = material.model;
        this.formItem.invalid = material.invalid;
        this.isInvalid = material.invalid;
        this.formItem.usedForSemi = material.usedForSemi || false;
        this.formItem.usedForProduct = material.usedForProduct || false;
        if (material.usedInFactory && material.usedInFactory.length > 1) {
          this.formItem.usedInFactory = material.usedInFactory
            .map(item => {
              return item._id;
            })
            .join(",")
            .split(",");
        }
        this.formItem.remark = material.remark;
      }
      this.drawerOpened = true;
    },
    changeInvalid(status) {
      this.formItem.invalid = status;
      this.isInvalid = status;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          try {
            if (this.openedMaterial) {
              await this.updateMaterial({
                id: this.openedMaterial._id,
                data: this.formItem
              });
            } else {
              let formItem = lodash.cloneDeep(this.formItem);
              for (const key in formItem) {
                if (!formItem[key]) {
                  delete formItem[key];
                }
              }
              await this.createMaterial({ ...formItem, type: this.type });
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    }
  }
};
</script>

<style scoped lang="stylus"></style>
